import apiRequest from "../../api/apiRequest";
import { successLogger } from "../../api/apiTester";
import { removeNullAndEmpty, storeFailedResponse } from "./helperModules/helperFunctions";
import { NblyContactMailModel } from "./interface/contact/nblyContactMailInterface";
import { startLoader, stopLoader } from "../../util/loader";
import { apiConfig } from "../../config/apiConfig";


export function isValidNblyBrandEmailPayload(payload: any): payload is NblyContactMailModel {
    const payloadLower = structuredClone(removeNullAndEmpty(payload));

    if (!payloadLower?.hasOwnProperty('sender')) {
        console.error('Missing mandatory field in Payload: sender');
        return false;
    }

   
    if (!payloadLower?.hasOwnProperty('templateId')) {
        console.error('Missing mandatory field in Payload: templateId');
        return false;
    }

    if (!payloadLower?.hasOwnProperty('receiver')) {
        console.error('Missing mandatory field in Payload: receiver');
        return false;
    }
    return payload;
}

export async function sendNblyBrandEmailWrapper(payload: any): Promise<NblyContactMailModel> {
    const suLogger = localStorage.getItem("suLogger") === 'true';

    const enableStrictValidation = process.env.ENABLE_STRICT_PAYLOAD_VALIDATION?.toLowerCase() === 'true';
    if (enableStrictValidation && !isValidNblyBrandEmailPayload(payload)) {
        console.error("Invalid payload for Nbly Contact Us Email:", payload);
        throw new Error(`Invalid payload: ${JSON.stringify(payload)}`);
    }

    const request = {
        method: 'POST',
        url: apiConfig.GENERIC_EMAIL_ENDPOINT,
        data: payload,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'apikey': process.env.VALIDATE_KEY
        },
        skipDeduplication: true,
    };

    try {
        startLoader();
        const response = await apiRequest(request);
        successLogger(request.data, request.url, suLogger, response);
        return response as NblyContactMailModel;
    } catch (err: any) {
        console.error('Error in sendNblyBrandEmailWrapper:', err);
        storeFailedResponse(request, err);
        throw new Error(`sendNblyBrandEmailWrapper failed: ${err.message || err}`);
    } finally {
        stopLoader();
    }
}
